// extracted by mini-css-extract-plugin
export default {"faces":"rate_faces__Gx1ac","face":"rate_face__y151R","custom":"rate_custom__yYwty","selected":"rate_selected__LYbGI","labels":"rate_labels__k72ML"};